import {z} from 'zod';

export const directSalesFilterOptionsResponseSchema = z.object({
  branches: z.array(z.string()),
  variants: z.array(z.string()),
});

export type DirectSalesFilterOptions = z.infer<typeof directSalesFilterOptionsResponseSchema>;
